import { datadogRum } from '@datadog/browser-rum';
import { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

function sanitizeViewName(viewName: string) {
    try {
        const replaceIds = viewName
            .toLowerCase()
            .replace(
                /\/(\d+[^\/]*|null|undefined|[^\/]*\.[a-z]+|[^\/]*[=%+][^\/]*)(?=\/|$)/g,
                '/{id}'
            ) // turn numbers, dates, file names, etc to {id} placeholder
            .replace(/(.+?)(\/+)$/, '$1') // remove '/' from the end of the line
            .replace(/(\/)(\/+)/g, '/') // remove duplicate '/'
            .replace('#', '');
        if (replaceIds.startsWith('/proxy')) {
            return replaceIds.replace(/^\/proxy/, '/').replace(/\/[^\/]*$/, '');
        }
        return replaceIds;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        return viewName;
    }
}

export const useConfigureDatadog = () => {
    const history = useHistory();
    const lastLocation = useRef(useLocation().pathname);

    useEffect(() => {
        try {
            datadogRum.startView(sanitizeViewName(lastLocation.current));
            const unregister = history.listen(location => {
                if (lastLocation.current !== location.pathname) {
                    datadogRum.startView(sanitizeViewName(location.pathname));
                    lastLocation.current = location.pathname;
                }
            });
            return unregister;
        } catch {} // eslint-disable-line no-empty
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
};
